import axios from "axios";
import { CONFIG, URL_AKM } from "../config";
import { configureSessionClient } from "./apiSession";

function client(baseURL) {
  return configureSessionClient(axios.create({ baseURL, timeout: 60000, withCredentials: false }));
}

export const uploadApi = client(CONFIG.ACCOUNT_MANAGEMENT_HOST);
export const metadataApi = client(URL_AKM.AKM_HOST);
export const metadataPath = "/soal/metadata";
export const isAdmin = true;
export const loadPackages = account => metadataApi.post("soal/uploadHistory", { idAdmin: account && account.idAdmin });

export async function loadContext(idKelas, idMataPelajaran) {
  const response = await uploadApi.get("/banksoal/context", { params: { idKelas: idKelas || undefined, idMataPelajaran: idMataPelajaran || undefined } });
  return response;
}
